(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 if (!('IntersectionObserver' in window) || window.Shopify?.designMode || document.documentElement.dataset.bloomReveal === 'false') return;
 const seen = new WeakSet();
 const reveal = el => { el.classList.add('bloom-reveal-ready'); el.classList.remove('bloom-reveal-pending'); observer.unobserve(el); };
 const observer = new IntersectionObserver(entries => { for (const entry of entries) if (entry.isIntersecting) reveal(entry.target); }, {threshold:0, rootMargin:'0px 0px -35px 0px'});
 const init = () => { document.querySelectorAll('#MainContent > .shopify-section').forEach(el => {
   if (seen.has(el)) return; seen.add(el);
   if (reduced.matches || el.getBoundingClientRect().top < innerHeight || el.querySelector('product-information,cart-items')) return;
   el.classList.add('bloom-reveal-pending');observer.observe(el);
 }); };
 document.addEventListener('focusin',e => { const el=e.target.closest?.('.bloom-reveal-pending');if(el) reveal(el); });
 reduced.addEventListener('change',()=>{if(reduced.matches) document.querySelectorAll('.bloom-reveal-pending').forEach(reveal);});
 document.addEventListener('shopify:section:load',init);
 addEventListener('pageshow',init);init();
})();
